<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :icon="alert_type === 'error' ? 'mdi-alert' : `$${alert_type}`" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Nav -->
    <header-component :headerTitle="headerText" />

    <!-- Update  popup  -->
    <v-row justify="center">
      <v-dialog v-model="UpdatePopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="UpdatePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-form>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="5" md="6">
                    <v-combobox color="primary" v-model="vendor_list_item" label="Vendor Name" :items="vendor_list" item-title="vendor_name" :loading="isLoading" item-value="vendor_code" @keydown.enter="handleKeyEnter($event)" variant="outlined"> </v-combobox>
                  </v-col>
                  <v-col cols="12" sm="5" md="6">
                    <v-text-field color="primary" v-model="formattedRepairQuotationValue" label="Repair Quotation Value (₹)" variant="outlined" required :rules="positiveRepairQuotationValue"> </v-text-field>
                    <!-- <v-text-field v-model="vendorCodeToSend" label="Vendor Code" outlined type="number" required :rules="positiveIntegerRules" @keydown.enter="updatedialogVendornamelist($event.target.value)" > </v-text-field> -->
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="5" md="6">
                    <v-autocomplete color="primary" v-model="repair_type_list" variant="outlined" :items="repair_type" item-title="name" item-value="id" label="Repair Type"> </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="5" md="6">
                    <v-autocomplete color="primary" v-model="expected_revised_grade_list" variant="outlined" :items="expected_revised_grade" item-title="name" item-value="id" label="Expected Revised Grade"> </v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" variant="outlined">
                    <v-file-input color="primary" v-model="file" accept=".pdf, .png" :rules="[fileTypeRule]" label="Upload Repair Job Sheet" @change="handleFileChange" variant="outlined" prepend-icon="" prepend-inner-icon="mdi-paperclip" />
                    <span v-if="file" class="file_name_css">{{ file.name.length > 20  ? file.name.slice(0,20) + '...' : file.name }} <span class="cursor-pointer mx-2" @click="file = null">x</span></span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="text-none cancel-color mb-3" @click="updatePendingQuotationCancel">Cancel</v-btn>
            <v-btn color="primary" variant="flat" class="text-none mb-3" :disabled="isSubmitDisabled" @click="updatePendingQuotationSubmit">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-repair" v-model="filterPopup" persistent max-width="1250px">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-row>
              <v-col v-if="active_tab === 'Pending Quotation' || active_tab === 'Pending Repair Approval' || active_tab === 'Pending Repair'">
                <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="article_id_search" label="Article ID" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col v-if="active_tab === 'Pending Quotation'">
                <v-autocomplete 
                  v-on:keyup.enter="loadData(active_tab)" 
                  color="primary" 
                  prepend-inner-icon="mdi-magnify" class="ma-2" 
                  v-model="grade_search_quo" variant="outlined" 
                  :items="filter_grades" 
                  item-title="name" item-value="id" label="Grade" multiple ref="gradeAutocomplete"> </v-autocomplete>
              </v-col>
              <v-col v-if="active_tab === 'Pending Repair Approval'">
                <v-autocomplete 
                  v-on:keyup.enter="loadData(active_tab)" 
                  color="primary" 
                  prepend-inner-icon="mdi-magnify" 
                  class="ma-2" 
                  v-model="grade_search_approval" 
                  variant="outlined" 
                  :items="filter_grades" 
                  item-title="name" item-value="id" label="Grade" multiple ref="gradeSearchAutocomplete"> </v-autocomplete>
              </v-col>
              <v-col v-if="active_tab == 'Pending Repair Approval'">
                <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="repair_quote_percentage_search" label="Repair Quote Percentage (%)" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col v-if="active_tab === 'Pending Repair Approval'">
                <v-autocomplete  
                v-on:keyup.enter="loadData(active_tab)" 
                color="primary" 
                prepend-inner-icon="mdi-magnify" 
                v-model="expected_revised_grade_search" 
                variant="outlined" 
                :items="filter_expected_revised_grade" 
                item-title="name" item-value="id" class="ma-2" label="Expected revised Grade" multiple ref="expectedGradeAutocomplete"> </v-autocomplete>
              </v-col>
              <v-col v-if="active_tab == 'Pending Repair'">
                <v-autocomplete  
                v-on:keyup.enter="loadData(active_tab)" 
                color="primary" 
                prepend-inner-icon="mdi-magnify" 
                v-model="repair_type_search" 
                variant="outlined" :items="filter_repair_type" item-title="name" item-value="id" label="Repair Type" class="ma-2" multiple ref="repairTypeAutocomplete"> </v-autocomplete>
              </v-col>
              <v-col v-if="active_tab == 'Pending Repair'">
                <v-autocomplete 
                v-on:keyup.enter="loadData(active_tab)" 
                class="ma-2" color="primary" 
                prepend-inner-icon="mdi-magnify" v-model="repair_status_search" variant="outlined" :items="filter_repair_status" item-title="name" item-value="id" label="Repair Status" multiple ref="repairStatusAutocomplete"> </v-autocomplete>
              </v-col>
              <v-col v-if="active_tab == 'Dispatch'">
                <v-combobox color="primary" 
                prepend-inner-icon="mdi-magnify" 
                v-model="repair_vendor_search" 
                variant="outlined" 
                :items="filter_vendor_list" 
                item-title="vendor_name" class="ma-2" item-value="vendor_code" :loading="isLoading" label="Repair Vendor" multiple @change="checkValidRepair" ref="repairVendorAutocomplete" @keydown.enter="handleKeyEnter($event)"> </v-combobox>
              </v-col>
              <v-col v-if="active_tab == 'Dispatch'">
                <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="repair_order_number_search" label="Repair Order Number" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col v-if="active_tab == 'Dispatch'">
                <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" v-model="status_search" :items="statusList" label="Status" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-autocomplete>
              </v-col>
              <v-col v-if="active_tab == 'Pending Disposition'">
                <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="article_id_search" label="Article ID" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col v-if="active_tab == 'Pending Disposition'">
                <v-autocomplete 
                v-on:keyup.enter="loadData(active_tab)" 
                color="primary" 
                prepend-inner-icon="mdi-magnify" 
                v-model="grade_search_disposition" label="Grade" :items="filter_disposition_expected_revised_grade" item-title="name" item-value="id" class="ma-2" variant="outlined" multiple ref="gradeSearchDisAutocomplete"></v-autocomplete>
              </v-col>
              <v-col v-if="active_tab == 'Pending Disposition'">
                <v-menu v-model="aspValue" :close-on-content-click="false" prepend-inner-icon="mdi-magnify" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-combobox color="primary" v-model="random" v-on="on" variant="outlined" label="Benchmark Price (₹)" :items="price_list"
                      class="ma-2">
                      <template v-slot:prepend-item>
                        <v-list>
                          <v-sheet>
                            <v-card-title><span>Range</span></v-card-title>
                            <div class="d-flex mb-2">
                              <div class="w-25">
                                <div class="d-flex align-items-center h-100 justify-center">Min</div>
                              </div>
                              <div class="w-75 px-2">
                                <v-text-field variant="outlined" hide-details type="number" label="Enter Price" v-model="minValue" class="ma-0" :rules="positiveIntegerRules"></v-text-field>
                              </div>
                            </div>
                            <div class="d-flex mb-2">
                              <div class="w-25">
                                <div class="d-flex align-items-center h-100 justify-center">Max</div>
                              </div>
                              <div class="w-75 px-2">
                                <v-text-field variant="outlined" hide-details type="number" label="Enter Price" v-model="maxValue" class="ma-0" :rules="positiveIntegerRules"></v-text-field>
                              </div>
                            </div>
                            <v-divider thickness="2"></v-divider>
                            <v-card-actions class="text-center">
                              <v-spacer></v-spacer>
                              <v-btn small variant="outlined" class="text-none " @click="cancelAspValues">Cancel</v-btn>
                              <v-btn small variant="flat" class="text-none " color="primary" @click="aspValue = !aspValue">Submit</v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-sheet>
                        </v-list>
                      </template>
                    </v-combobox>
                  </template>
                </v-menu>
              </v-col>
               <v-col>
                <v-autocomplete  color="primary"
                  v-model="putaway_filter" variant="outlined" :items="puttawayList"
                   label="Putaway Status" class="ma-2">
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="normal" class="text-none" @click="closeFilterpopup">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="text-none" @click="applyFilterFunc">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Pending Quotation -->
    <v-row justify="center">
      <v-dialog v-model="datadetailpopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="datadetailpopup = !datadetailpopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article ID</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Grade</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.grade ? item_details.grade : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Quotation Details</span>
                  </v-col>
                  <v-col cols="6">
                    <span :disabled="(this.selected.length == 0)">
                      <v-btn class="link-color cursor-pointer text-none" @click="itemDialogUpdatePopup" variant="plain"> update</v-btn>
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Pending Repair Approval -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailPopupPendingRepairApproval" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dataDetailPopupPendingRepairApproval = !dataDetailPopupPendingRepairApproval">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article ID</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Grade</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.grade ? item_details.grade : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Benchmark Price</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.benchmark_price ? item_details.benchmark_price : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Repair Quote</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.repair_amount ? item_details.repair_amount : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Repair Quote Percentage</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.repair_quote_percentage ? item_details.repair_quote_percentage : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Expected Revised Grade</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.formatted_expected_revised_grade ? item_details.formatted_expected_revised_grade : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Pending Repair -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailPendingRepairPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dataDetailPendingRepairPopup = !dataDetailPendingRepairPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article ID</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Repair Type</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.repair_type_location ? item_details.repair_type_location : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Repair Status</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.current_repair_status ? item_details.current_repair_status : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Dispatch -->
    <v-row justify="center">
      <v-dialog v-model="dataDispatchPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dataDispatchPopup = !dataDispatchPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article ID</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Repair Vendor</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.repair_vendor ? item_details.repair_vendor : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Repair Order number</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.order_number ? item_details.order_number : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Returnable DC Number</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.returnable_dc_number ? item_details.returnable_dc_number : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Repair Quote</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.repair_quote ? item_details.repair_quote : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Status</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.status ? item_details.status : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Pending-Disposition -->
    <v-row justify="center">
      <v-dialog v-model="datadetailpopupdisposition" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="datadetailpopupdisposition = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article ID</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Grade</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ item_details.formatted_expected_revised_grade ? item_details.formatted_expected_revised_grade :
                      '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Benchmark Price</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ item_details.benchmark_price }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Net Recovery</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ item_details.repair_amount ? item_details.repair_amount : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Net Recovery%</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ item_details.repair_quote_percentage ? item_details.repair_quote_percentage : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Approve confirm popup in Pending-Repair-Approval Screen -->
    <v-row justify="center">
      <v-dialog v-model="approveconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approveconfirmpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> Are you sure you want to Approve?</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="mb-3 bg-blue text-none" v-if="(active_tab == 'Pending Repair Approval')" :disabled="number > 0" @click="adminApproveItem('approve')">Yes</v-btn>
            <v-btn color="white" class="mb-3 bg-blue text-none" v-if="(active_tab == 'Pending Disposition')" :disabled="number > 0" @click="adminApproveDispositionItem">Yes</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Reject confirm popup in Pending-Repair-Approval Screen -->
    <v-row justify="center">
      <v-dialog v-model="rejectconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="rejectconfirmpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> Are you sure you want to Reject?</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="mb-3 bg-blue text-none" v-if="(active_tab == 'Pending Repair Approval')" :disabled="number > 0" @click="adminRejectItem('reject')">Yes</v-btn>
            <v-btn color="white" class="mb-3 bg-blue text-none" v-if="(active_tab == 'Pending Disposition')" :disabled="number > 0" @click="adminRejectDispositionItem">Yes</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Approve Ok confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="okapproveconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="text-center" v-if="(active_tab == 'Pending Repair Approval')">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-text class="text-center" v-if="(active_tab == 'Pending Repair')">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-text class="text-center" v-if="(active_tab == 'Pending Quotation')">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-text class="text-center" v-if="(active_tab == 'Pending Disposition')">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="mb-3 bg-blue text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Reject Ok confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="okrejectconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="text-center" v-if="(active_tab == 'Pending Repair Approval')">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-text class="text-center" v-if="(active_tab == 'Pending Repair')">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="mb-3 bg-blue text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dispatch confirm popup in Pending-Repair Screen -->
    <v-row justify="center">
      <v-dialog v-model="dispatchconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dispatchconfirmpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center" v-if="(active_tab == 'Pending Repair')">
            <span> Are you sure you want to Dispatch to service Center</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn class="mb-3 bg-color text-none" :disabled="number > 0" @click="adminDispatchItem">Yes</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Update popup in pending-Repair -->
    <v-row justify="center">
      <v-dialog v-model="updatePendingRepairPopup" persistent max-width="366px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span class="font-weight-bold">Repair Status</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="updatePendingRepairColsePopup">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-card-text>
            <v-container>
             <v-row>
              <v-col cols="6" sm="12" md="12" style="height: 96px;">
                <v-autocomplete v-model="rejectPendingRepair" variant="outlined" :items="repair_filter_status" item-title="name"
                  item-value="id" label="Pending Repair" style="max-width: 300px;" hide-details></v-autocomplete> <br>
              </v-col>
              </v-row>
              <v-row v-if="rejectNotRepaired == 'Not repaired'">
              <v-col cols="6" sm="12" md="12" style="height: 96px;">
                <v-text-field prepend-inner-icon="mdi-magnify" style="max-width: 300px;" v-model="reason" label="Reason" variant="outlined" > </v-text-field>
              </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="12" md="12">
                  <v-file-input color="primary" v-model="file" accept=".pdf, .png" :rules="[fileTypeRule]" label="Upload Repair Job Sheet" @change="handleFileChange" variant="outlined" prepend-icon="" prepend-inner-icon="mdi-paperclip" />
                    <span v-if="file" class="file_name_css">{{ file.name.length > 20  ? file.name.slice(0,20) + '...' : file.name }} <span class="cursor-pointer mx-2" @click="file = null">x</span></span>
                </v-col>
              </v-row>
              
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="text-none mb-3" @click="adminUpdatePendingRepairItem"
              :disabled="!disabledButton">Submit</v-btn>
            <v-btn variant="outlined" class="text-none cancel-color mb-3" @click="updatePendingRepairColsePopup">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Header -->
    <v-card class="v-card-100 mt-6">
      <v-tabs color="primary" v-model="selected_tab">
        <v-tab ripple @click="loadData(tab, 'tab_clicked')" style="text-transform:none!important;text-decoration: none;" class="tab-color" v-for="(tab, index) in tabs" :key="index">
          {{ tab }}
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- search, filter, Action buttons -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style">
    <v-row>
      <!-- Search fields -->
      <v-row>
          <v-combobox class="text-left ma-4" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;"> </v-combobox>
          <v-text-field class="my-4" prepend-inner-icon="mdi-magnify" :disabled="!select_field" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 300px;" variant="outlined" color="primary" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
      </v-row>

      <!-- Actions buttons -->
      <v-card-actions style="margin-bottom: 10px; margin-top:-7px">
        <v-btn class="mr-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0)" v-if="active_tab == 'Pending Quotation' && isActionAllowed(role)" @click="updatedialog">Update</v-btn>
        <v-btn class="mr-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0)" v-if="active_tab == 'Pending Repair Approval' && currentUser.roles.includes('central_admin') && isActionAllowed(role)" @click="approveConfirmPopup">Approve</v-btn>
        <v-btn class="mr-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0)" v-if="active_tab == 'Pending Repair Approval' && currentUser.roles.includes('central_admin') && isActionAllowed(role)" @click="rejectConfirmPopup">Reject</v-btn>
        <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="(this.selected.length == 0)" variant="flat" v-if="active_tab == 'Pending Repair' && isActionAllowed(role)" @click="dispatchConfirmPopup">Dispatch</v-btn>
        <v-btn class="mr-2 text-none" size="x-large" color="primary" variant="flat" :disabled="disableUpdatePendingrepair()" v-if="active_tab == 'Pending Repair' && isActionAllowed(role)" @click="updatePendingRepairDialog">Update</v-btn>
        <v-btn class="mr-2 text-none" size="x-large" color="primary" @click="navigateToFileUpload"  variant="flat" v-if="active_tab == 'Pending Repair' && ($isRelianceClient() || $isWhirlpoolClient()) && isActionAllowed(role)">Upload</v-btn>
        <template>
          <div class="text-center mr-3" v-if="(active_tab == 'Pending Disposition') && this.currentUser.roles.includes('default_user') && isActionAllowed(role)">
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <v-btn color="primary" variant="flat" size="x-large" v-bind="props" :disabled="selected.length == 0" class="text-none">
                  Assign Disposition
                  <v-icon dark>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in assign_disposition_list" :key="index" @click="assignDisposition(item)">
                  <v-list-item-title>{{ item.original_code }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <v-btn class="ma-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0)" v-if="active_tab == 'Pending Disposition' && currentUser.roles.includes('central_admin') && isActionAllowed(role)" @click="approveConfirmPopup">Approve</v-btn>
        <v-btn class="ma-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0)" v-if="active_tab == 'Pending Disposition' && currentUser.roles.includes('central_admin') && isActionAllowed(role)" @click="rejectConfirmPopup">Reject</v-btn>
      </v-card-actions>

      <!-- Filter -->
      <v-expansion-panels v-if="active_tab !== 'Pending For Approval'" class="custom-control_outlined ma-2" ref="filterPopupRef" readonly
        style="max-width: 300px; margin-bottom: 16px; height: 52px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px;">
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-row>
    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%"
          :loading="loading"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait" class="elevation-1"
          return-object
          >
          <template #[`header.disposition_age`]="{ column }">
            <span>{{ column.title }}
              <AgeingTooltip />
            </span>
          </template>
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
            <span v-if="header.key == 'item_id' && active_tab !== 'Dispatch'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.item_id }}</u></a>
            </span> 
              <span v-else-if="header.key == 'tag_number' && active_tab === 'Dispatch'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key === 'benchmark_price' && !item.update">
                <span>{{ item.benchmark_price ? item.benchmark_price.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key === 'repair_amount' && !item.update">
                <span>{{ item.repair_amount ? item.repair_amount.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key === 'repair_quote' && !item.update">
                <span>{{ item.repair_quote ? item.repair_quote.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template v-if="active_tab != 'Dispatch'" #[`item.item_id`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2;" class="cursor-pointer">
              <u> {{ item.item_id }}</u>
            </a>
          </template>
          <template v-if="active_tab == 'Dispatch'" #[`item.tag_number`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2;" class="cursor-pointer">
              <u> {{ item.tag_number }}</u>
            </a>
          </template> -->
          <!-- <template #[`item.repair_quote_percentage`]="{ item }">
            <span>{{ item.repair_quote_percentage ? item.repair_quote_percentage : "-" }}</span>
          </template>
          <template #[`item.repair_type_location`]="{ item }">
            <span>{{ item.repair_type_location ? item.repair_type_location : "-" }}</span>
          </template> -->
          <!-- <template #[`item.benchmark_price`]="{ item }">
            <span>{{ item.benchmark_price ? item.benchmark_price.toLocaleString('en-IN') : '-' }}</span>
          </template>
          <template #[`item.repair_amount`]="{ item }">
            <span>{{ item.repair_amount ? item.repair_amount.toLocaleString('en-IN') : '-' }}</span>
          </template>
          <template #[`item.repair_quote`]="{ item }">
            <span>{{ item.repair_quote ? item.repair_quote.toLocaleString('en-IN') : '-' }}</span>
          </template> -->
          <!-- <template #[`item.returnable_dc_number`]="{ item }">
            <span>{{ item.returnable_dc_number ? item.returnable_dc_number : '-' }}</span>
          </template>
          <template #[`item.repair_cost`]="{ item }">
            <span>{{ item.repair_cost ? item.repair_cost : '-' }}</span>
          </template>
          <template #[`item.sub_location_name`]="{ item }">
            <span>{{ item.sub_location_name ? item.sub_location_name : '-' }}</span>
          </template>     -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>

    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
  // import $ from 'jquery';
  // import Editor from "@tinymce/tinymce-vue";
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';
  // import { securedAxiosInstance, plainAxiosInstance } from '@/backend/axios';
  // import { strict } from 'assert';
  // import { required, minLength, helpers } from 'vuelidate/lib/validators';
  import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'

  export default {
    components: {
      HeaderComponent
    },
    data() {
      return {
        headerText: "Repair",
        currentUser: {},
        tabs: [
          "Pending Quotation",
          "Pending Repair Approval",
          "Pending Repair",
          "Dispatch",
          "Pending Disposition",
          "Pending For Approval",
        ],
        dialog: false,
        dialog_update: "Update",
        headers: [
          { title: "Tag ID", align: "start", sortable: false, key: "item_id" },
          { title: "Article ID", key: "article_id" },
          { title: "Article Description", key: "article_description" },
          { title: "Grade", key: "grade" },
        ],
        selected: [],
        active_tab: "Pending Quotation",
        table_data: [],
        original_table_data: [],
        page: 1,
        totalPages: 1,
        selected_tab: 0,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        search_tag: '',
        UpdatePopup: false,
        isShow: true,
        repair_id: [],
        expected_revised_grade: '',
        filterPopup: false,
        article_id_search: '',
        grade_search_disposition: [],
        repair_quote_percentage_search: null,
        expected_revised_grade_search: [],
        datadetailpopup: false,
        dataDetailPopupPendingRepairApproval: false,
        dataDetailPendingRepairPopup: false,
        dataDispatchPopup: false,
        tag_number: '',
        item_details: [],
        approveconfirmpopup: false,
        rejectconfirmpopup: false,
        dispatchconfirmpopup: false,
        updatePendingRepairPopup: false,
        repair_status: '',
        rejectPendingRepair: null,
        vendor_name: '',
        repair_quotation_value: '',
        repair_type: '',
        expected_revised_grade: '',
        rejectsussesspopup: false,
        updatemessage: '',
        itemLength: '',
        file: '',
        pending_quotation_attachments: '',
        tag_id: '',
        repair_vendor: '',
        repair_order_number: '',
        status: '',
        selectedDisposition: '',
        assign_disposition_list: [],
        successmessage: '',
        search: '',
        number: 0,
        okapproveconfirmpopup: false,
        okrejectconfirmpopup: false,
        vendor_list: '',
        vendorCodeTosend: '',
        vendor_code: '',
        tag_id_search: '',
        repair_vendor_search: [],
        repair_order_number_search: '',
        status_search: '',
        repair_type_search: [],
        repair_status_search: [],
        benchmark_price_search: '',
        datadetailpopupdisposition: false,
        repair_filter_status: [],
        repair_type_list: '',
        expected_revised_grade_list: '',
        filter_grades: '',
        filter_repair_type: '',
        filter_repair_status: '',
        filter_vendor_list: '',
        filter_disposition_expected_revised_grade: '',
        vendor_code_update: [],
        message: '',
        grade_search_quo: [],
        grade_search_approval: [],
        maxValue: '',
        minValue: '',
        vendor_list_item: null,
        alert: false,
        alert_type: 'info',
        alert_message: '',
        currentUser: {},
        item_id: '',
        isLoading: false,
        aspValue: false,
        price_list: '',
        role:'',
        select_field_items: [
        {
          "name":"Tag ID",
          "id": "tag_number"
        },
        {
          "name":"Serial Number",
          "id": "serial_number"
        },
        {
          "name":"IRD Number",
          "id": "ird_number"
        },
        {
          "name":"IRRD Number",
          "id": "irrd_number"
        }
        ],
        select_field:null,
        positiveIntegerRules: [
          (value) => Number(value) >= 0 || 'Value must be a positive integer',
        ],
        invalidFileType: false,
        statusList: ["Pending Pick-Up", "Pending Packaging", "Pending Dispatch", "Pending Disposition"],
        organization_name:'',
        putaway_filter:null,
        puttawayList:["Pending","Completed"],
        isFiltering:false,
        reason: null
      }
    },

    computed: {
      fileTypeRule() {
        return (value) => {
          if (!value) {
            this.invalidFileType = false;
            return true;
          }
          const allowedTypes = ['.png', '.pdf'];
          const fileType = value && value.name ? value.name.slice(value.name.lastIndexOf('.')) : '';
          this.invalidFileType = !allowedTypes.includes(fileType);
          return !this.invalidFileType || 'Invalid file type';

        };
      },
      rejectNotRepaired() {
          const selectedStatus = this.repair_filter_status.filter(item => item.id == this.rejectPendingRepair);
          if (selectedStatus.length > 0) {
            return selectedStatus[0].name;
          }
          return '';
        },
        disabledButton() {
          if(this.rejectNotRepaired === "Not repaired"){
            return this.reason && this.rejectPendingRepair;
          }else{
            return this.rejectPendingRepair;
          }
        },
      isSubmitDisabled() {
        // Check if any required field is empty
        if (
          !this.vendor_list_item ||
          !this.repair_quotation_value ||
          !this.repair_type_list ||
          !this.expected_revised_grade_list ||
          !this.isFileTypeValid() ||
          this.number > 0
        ) {
          return true; // Disable the submit button
        }
        return false; // Enable the submit button
      },
      formattedRepairQuotationValue: {
        get() {
          return (this.repair_quotation_value).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.repair_quotation_value = Math.max(parseFloat(numericValue), '');
        }
      },
    },

    async created() {
      this.role = this.$store.state.currentUser.roles[0]
      if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Repair')){
        signout()
        return;
      }
      this.currentUser = this.$store.state.currentUser;
      this.organization_name = this.$store.state.organization_name;
      const tab = this.$store.state.active_tab
      if(tab == 'Pending Disposition'){
        this.loadData('Pending Disposition')
        this.selected_tab = 4
      } else if(tab == 'Dispatch'){
        this.loadData('Dispatch')
        this.selected_tab = 3
      } else if(tab == 'Pending Repair'){
        this.loadData('Pending Repair')
        this.selected_tab = 2
      } else if(tab == 'Pending Repair Approval'){
        this.loadData('Pending Repair Approval')
        this.selected_tab = 1
      } else {
        this.loadData('Pending Quotation');
        this.selected_tab = 0
      }
      this.scrollToTop();
    },

    watch: {
      selected(newVal) {
        if (this.active_tab === 'Pending Repair') {
          const putawayInward = newVal.filter(insurances => insurances.is_putaway_inwarded === false)
          const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
          if (putawayInward.length > 0) {            
            this.$nextTick(() => {
              this.showAlert("warning", "Please complete Putaway Process");
              this.selected = [];
            });
          }else if(isUnderPhysicalInspection.length > 0){
            this.$nextTick(() => {
              this.showAlert("warning", "Action on item blocked as it is under cycle count process");
              this.selected = [];
            });
          }
        }
      },
      grade_search_quo(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.gradeAutocomplete.internalSearch = '';
          });
        }
      },
      grade_search_approval(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.gradeSearchAutocomplete.internalSearch = '';
          });
        }
      },
      expected_revised_grade_search(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.expectedGradeAutocomplete.internalSearch = '';
          });
        }
      },
      repair_type_search(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.repairTypeAutocomplete.internalSearch = '';
          });
        }
      },
      repair_status_search(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.repairStatusAutocomplete.internalSearch = '';
          });
        }
      },
      repair_vendor_search(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.repairVendorAutocomplete.internalSearch = '';
          });
        }
      },
      grade_search_disposition(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.gradeSearchDisAutocomplete.internalSearch = '';
          });
        }
      },
      selected(newVal) {
        const putawayInward = newVal.filter(liquidation => liquidation.is_putaway_inwarded === false)
        if(putawayInward.length > 0 && this.active_tab === 'Pending Repair'){
          this.showAlert("warning", "Please complete Putaway Process");
          this.selected = []
        }      
      },
    },


    methods: {
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Repair')
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      getRequestParams(page, pageSize) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        if (pageSize) {
          params["size"] = pageSize;
        }

        return params;
      },

      // show Alert messages
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },


      // loading the table data to the table

      loadData(tab, tab_action) {
        if (tab_action) {
          this.search_tag = '';
          this.select_field = null;
        }
        this.isFiltering = false
        this.loading = true;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        this.select_field_items = [
              {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"Serial Number",
                "id": "serial_number"
              },
              {
                "name":"IRD Number",
                "id": "ird_number"
              },
              {
                "name":"IRRD Number",
                "id": "irrd_number"
              }]
        if (tab == "Pending Quotation") {
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key: "item_id", minWidth: "200px" },
            { title: "Article ID", key: "article_id", minWidth: "200px" },
            { title: "Article Description", key: "article_description", minWidth: "200px" },
            { title: "Grade", key: "grade", minWidth: "200px" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);
          this.fetchPendingQuotation();
          this.fetchFilterGradePendingQuotation();
        }
        if (tab == 'Pending Repair Approval') {
          (this.headers = [
            { title: "Tag ID", key: "item_id", minWidth: "200px", align: "start", sortable: false },
            { title: "Article ID", key: "article_id", minWidth: "200px" },
            { title: "Grade", key: "grade", minWidth: "200px" },
            { title: "Benchmark Price (₹)", key: "benchmark_price", minWidth: "250px" },
            { title: "Repair Quote (₹)", key: "repair_amount", minWidth: "200px" },
            { title: "Repair Quote Percentage (%)", key: "repair_quote_percentage", minWidth: "300px" },
            { title: "Expected Revised Grade", key: "formatted_expected_revised_grade", minWidth: "300px" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);
          this.fetchPendingRepairApproval();
          this.fetchFilterGradePendingRepairApproval()

        }
        if (tab == 'Pending Repair') {
          (this.headers = [
            { title: "Tag ID", key: "item_id", width: '12%', align: "start", sortable: false, minWidth: "200px" },
            { title: 'Article ID', key: 'article_id', minWidth: "200px" },
            { title: 'Article Description', key: 'article_description', minWidth: "200px" },
            { title: 'Repair Types', key: 'repair_type_location', minWidth: "200px" },
            { title: 'Repair Status', key: 'current_repair_status', minWidth: "200px" },
            { title: 'Repair cost', key: 'repair_cost', minWidth: "200px" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);
          this.fetchPendingRepair();
          this.fetchFilterPendingRepair();
        }
        if (tab == 'Dispatch') {
          (this.headers = [
            { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false, minWidth: "200px" },
            { title: 'Repair Vendor', key: 'repair_vendor', minWidth: "200px" },
            { title: 'Repair Order Number', key: 'order_number', minWidth: "250px" },
            { title: 'Returnable DC Number', key: 'returnable_dc_number', minWidth: "250px" },
            { title: 'Repair Quote (₹)', key: 'repair_quote', minWidth: "200px" },
            { title: "Ageing", key:"disposition_age"},
            { title: 'Status', key: 'status', minWidth: "200px" },
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);
          this.fetchDispatch();
          // this.fetchFilterDispatch();
        }
        if (((tab == 'Pending Disposition') && (this.currentUser.roles.includes('central_admin'))) || ((tab == 'Pending Disposition') && (this.currentUser.roles.includes('admin')))) {
          (this.headers = [
            { title: "Tag ID", key: "item_id", minWidth: "200px", align: "start", sortable: false },
            { title: 'Article ID', key: 'article_id', minWidth: "200px" },
            { title: 'Article Description', key: 'article_description', minWidth: "200px" },
            { title: 'Grade', key: 'formatted_expected_revised_grade', minWidth: "200px" },
            { title: 'Assigned Disposition', key: 'disposition_name', minWidth: "200px" },
            { title: 'Benchmark Price (₹)', key: 'benchmark_price', minWidth: "200px" },
            { title: 'Net Recovery (₹)', key: 'repair_amount', minWidth: "200px" },
            { title: 'Net Recovery (%)', key: 'repair_quote_percentage', minWidth: "200px" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);
          this.fetchPendingDisposition();
          this.fetchFilterPendingDisposition();
          this.assignDispositionList();
        }
        if ((tab == 'Pending Disposition') && (this.currentUser.roles.includes('default_user'))) {
          (this.headers = [
            { title: "Tag ID", key: "item_id", minWidth: "200px", align: "start", sortable: false },
            { title: 'Article ID', key: 'article_id', minWidth: "200px" },
            { title: 'Article Description', key: 'article_description', minWidth: "200px" },
            { title: 'Grade', key: 'formatted_expected_revised_grade', minWidth: "200px" },
            { title: 'Benchmark Price (₹)', key: 'benchmark_price', minWidth: "200px" },
            { title: 'Net Recovery (₹)', key: 'repair_amount', minWidth: "200px" },
            { title: 'Net Recovery (%)', key: 'repair_quote_percentage', minWidth: "200px" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },

          ]);
          this.fetchPendingDisposition();
          this.fetchFilterPendingDisposition();
          this.assignDispositionList();
        }
        if ((tab == 'Pending For Approval')) {
          this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
          this.select_field_items = [
             {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"Lot ID",
                "id": "lot_id"
              },
              {
                "name":"Publish ID",
                "id": "publish_id"
              },
              {
                "name":"Pending at",
                "id": "pending_at"
              }];
          this.fetchPendingForApproval();
        }
      },

      // fetch the data from the API to load data to the table

      fetchPendingQuotation() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/index_new",
            {
              params:
              {
                ...params,                
                status: 'Pending Quotation',
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.repairs
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });

      },

      fetchFilterGradePendingQuotation() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_filters_data",
            {
              params:
              {
                ...params,
                status: 'Pending Quotation',
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.filter_grades = response.data.grades
              this.filter_expected_revised_grade = response.data.expected_revised_grade
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },


      fetchPendingRepairApproval() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/index_new",
            {
              params:
              {
                ...params,
                status: 'Pending Repair Approval',
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.repairs
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },


      fetchFilterGradePendingRepairApproval() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_filters_data",
            {
              params:
              {
                ...params,
                status: 'Pending Repair Approval',
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.filter_grades = response.data.grades
              this.filter_expected_revised_grade = response.data.expected_revised_grade
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },


      fetchPendingRepair() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/index_new",
            {
              params:
              {
                ...params,
                status: 'Pending Repair',
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.repairs
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      fetchFilterPendingRepair() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_filters_data",
            {
              params:
              {
                ...params,
                status: 'Pending Repair',
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.filter_repair_type = response.data.repair_type
              this.filter_repair_status = response.data.repair_statuse
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      fetchDispatch() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/repair_dispatch_items",
            {
              params:
              {
                ...params,
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingForApproval() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/index_new?status=pending_approval",
            {
              params:
              {
                ...params,
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.repairs
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchFilterDispatch(val) {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        const params2 = {
          query: val,
        }
        this.isLoading = true;
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_vendor_master",
            {
              params: params2
              // params: 
              // { 
              //   tag_number:this.search_tag,
              //   page: params['page'], 
              //   per_page: params['size'] 
              // } 
            })
          .then(response => {
            if (response.data) {
              this.filter_vendor_list = response.data.vendor_masters
              this.isLoading = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingDisposition() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/index_new",
            {
              params:
              {
                ...params,
                status: 'Pending Disposition',
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.repairs
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      fetchFilterPendingDisposition() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_filters_data",
            {
              params:
              {
                ...params,
                page: params['page'],
                per_page: params['size']
              }
            })
          .then(response => {
            if (response.data) {
              this.filter_disposition_expected_revised_grade = response.data.expected_revised_grade
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // To handle the page change

      handlePageChange(value) {
        this.page = value;
        this.filterPageNo = 1;
          if(this.isFiltering){
              this.applyFilterFunc();
              return;
          }
        if (this.active_tab == 'Pending Quotation') {
          this.fetchPendingQuotation();
        } else if (this.active_tab == 'Pending Repair Approval') {
          this.fetchPendingRepairApproval();
        } else if (this.active_tab == 'Pending Repair') {
          this.fetchPendingRepair();
        } else if (this.active_tab == 'Dispatch') {
          this.fetchDispatch();
        } else if(this.active_tab == 'Pending For Approval'){
          this.fetchPendingForApproval();
        }else {
          this.fetchPendingDisposition();
        }
      },

      //  To handle the page size change
      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        if (this.active_tab == 'Pending Quotation') {
          this.fetchPendingQuotation();
        } else if (this.active_tab == 'Pending Repair Approval') {
          this.fetchPendingRepairApproval();
        } else if (this.active_tab == 'Pending Repair') {
          this.fetchPendingRepair();
        } else if (this.active_tab == 'Dispatch') {
          this.fetchDispatch();
        } else if(this.active_tab == 'Pending For Approval'){
          this.fetchPendingForApproval();
        } else {
          this.fetchPendingDisposition();
        }
      },

      // To handle the file upload
      handleFileChange(event) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          // this.file = reader.result;
        };
        reader.readAsBinaryString(file);
      },
      selectFile(event) {
        this.file = event.target.files[0]
        const reader = new FileReader()
        reader.readAsBinaryString(this.file)
        reader.onload = () => {
          this.binaryData = btoa(reader.result)
        }
      },

      itemDialogUpdatePopup() {
        this.UpdatePopup = true;
        this.number = 0;
        this.datadetailpopup = false;
        this.updatedialog();
      },

      // Update Dialog for Pending Quotation Tab
      updatedialog() {
        this.updatedialogVendornamelist('');
        this.UpdatePopup = true;
        this.number = 0;
        this.vendor_list_item = null;
        this.repair_id = this.selected.map(repairs => repairs.id)
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_filters_data", { params: { id: this.repair_id } })
          .then(response => {
            if (response.data) {
              this.repair_type = response.data.repair_type;
              this.expected_revised_grade = response.data.expected_revised_grade;
              // this.vendor_list_item='';
              this.repair_quotation_value = '';
              this.repair_type_list = null;
              this.expected_revised_grade_list = null;
              this.file = '';
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          })
      },
      checkValidRepair() {
        if (this.repair_vendor_search.length >= 2) {
          const secondLastIndex = this.repair_vendor_search.length - 2;
          if (typeof this.repair_vendor_search[secondLastIndex] !== 'object') {
            this.repair_vendor_search.splice(secondLastIndex, 1);
          }
        }
      },
      handleKeyEnter(event) {
        if (this.active_tab == "Pending Quotation") {
          this.updatedialogVendornamelist(event.target.value);
        } else if (this.active_tab == "Dispatch") {
          this.fetchFilterDispatch(event.target.value);
        }
      },
      // Update dialog vendors name list in pending-Quotation screen
      updatedialogVendornamelist(val) {
        this.isLoading = true;
        const params = {
          query: val,
        }
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_vendor_master", { params: params })
          .then(response => {
            if (response.data) {
              this.vendor_list = response.data.vendor_masters
              this.isLoading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          })
      },

      // submit on update dialog in Pending-Quotation
      updatePendingQuotationSubmit() {

        this.number++;
        if (!this.vendor_list_item.vendor_code) {
          this.$toast.error("Please select valid vendor name.");
          this.number = 0;
          return;
        }

        const repairDetails = {
          "ids": [],
          "status": this.active_tab,
          "vendor_code": this.vendor_list_item.vendor_code,
          "repair_quotation_value": this.repair_quotation_value,
          "repair_type": this.repair_type_list,
          "expected_revised_grade": this.expected_revised_grade_list,
        }

        if (this.selected.length == 0) {
          this.repair_id = this.item_id;
          repairDetails.ids.push(this.item_id);
        } else {
          this.repair_id = this.selected.map(repairs => repairs.id)
          for (const id of this.repair_id) {
            repairDetails.ids.push(id);
          }
        }

        const formData = new FormData();
        formData.append("job_sheet", this.file);
        for (const key in repairDetails) {
          formData.append(`repair_details[${key}]`, (repairDetails[key]));
        }

        this.$httpSecured.put("/api/v1/warehouse/new_repairs/update_pending_quotation", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.vendor_name = '';
              this.repair_quotation_value = '';
              this.repair_type = '';
              this.expected_revised_grade = '';
              this.file = '';
              this.vendorNameToSend = '';
              this.UpdatePopup = false;
              this.updatemessage = 'Pending Quotation';
              this.okapproveconfirmpopup = true;
              this.itemLength = this.selected.length;
              this.showAlert("success", "Successfully updated");
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.number = 0;
            this.loading = false;
          });
      },

      //  Update in pending-Quotation popup close
      updatePendingQuotationCancel() {
        this.vendor_name = '';
        this.repair_quotation_value = '';
        this.repair_type = '';
        this.expected_revised_grade = '';
        this.UpdatePopup = false;
        this.file = null;
        this.invalidFileType = false;
        this.vendorNameToSend = '';
      },


      // filter Dialog PopUP 
      filterListOfButtons(ev) {
        this.filterPopup = true;
        // this.putaway_filter = null;
        this.article_id_search = ''
        this.grade_search_quo = []
        this.grade_search_approval = []
        this.repair_quote_percentage_search = ''
        this.expected_revised_grade_search = []
        this.repair_type_search = []
        this.repair_status_search = []
        this.repair_vendor_search = []
        this.repair_order_number_search = ''
        this.status_search = ''
        this.article_id_search = ''
        this.grade_search_disposition = []
        this.benchmark_price_search = ''
        this.minValue = ''
        this.maxValue = ''
        this.putaway_filter = null;
        if (this.active_tab == 'Dispatch') {
          this.fetchFilterDispatch('');
        }
      },


      // Item dialog popup in pending Quotation
      itemDetailpopup(item) {
        if (this.active_tab == 'Pending Quotation') {
          this.datadetailpopup = true;
          this.tag_number = item.item_id;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
            .get(`/api/v1/warehouse/new_repairs/${this.item_id}`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.repair
                this.require_doc = response.data.repair.pending_quotation_attachments
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        } else if (this.active_tab == 'Pending Repair Approval') {
          this.dataDetailPopupPendingRepairApproval = true;
          this.tag_number = item.item_id;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
            .get(`/api/v1/warehouse/new_repairs/${this.item_id}`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.repair
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        } else if (this.active_tab == 'Pending Repair') {
          this.dataDetailPendingRepairPopup = true;
          this.tag_number = item.item_id;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
            .get(`/api/v1/warehouse/new_repairs/${this.item_id}`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.repair
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }
        else if (this.active_tab == 'Dispatch') {
          this.dataDispatchPopup = true;
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
            .get(`/api/v1/warehouse/new_repairs/repair_dispatch_item?id=${this.item_id}`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.warehouse_order_item
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }
        else if (this.active_tab == 'Pending Disposition') {
          this.datadetailpopupdisposition = true;
          this.tag_number = item.item_id;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
            .get(`/api/v1/warehouse/new_repairs/${this.item_id}`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.repair
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }

      },


      // Approve Dialog in Pending Repair Aproval
      approveConfirmPopup() {
        this.approveconfirmpopup = true;
      },

      // Admin Approve function after Approved by clicking yes
      adminApproveItem(approvalStatus) {
        this.number++;
        this.repair_id = this.selected.map(repairs => repairs.id);
        const repairDetails = {
          "ids": this.repair_id,
          "status": this.active_tab,
          "repair_approval": approvalStatus,
          "repair_status": ""
        }
        this.$httpSecured.put('/api/v1/warehouse/new_repairs/update_details',
          {
            "repair_details": repairDetails
          },)
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.approveconfirmpopup = false;
              this.okapproveconfirmpopup = true;
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;

          });
      },

      afterClickOkLoadData() {
        this.okapproveconfirmpopup = false;
        this.okrejectconfirmpopup = false;
        this.loadData(this.active_tab);
      },

      // Reject Dialog in Pending Repair Aproval
      rejectConfirmPopup() {
        this.rejectconfirmpopup = true;
      },


      // Admin Reject function after rejecting by clicking yes
      adminRejectItem(approvalStatus) {
        // post method to send the response
        this.number++;
        this.repair_id = this.selected.map(repairs => repairs.id);
        const repairDetails = {
          "ids": this.repair_id,
          "status": this.active_tab,
          "repair_approval": approvalStatus,
          "repair_status": ""
        }
        this.$httpSecured.put('/api/v1/warehouse/new_repairs/update_details',
          {
            "repair_details": repairDetails
          },)
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.rejectconfirmpopup = false;
              this.okrejectconfirmpopup = true;
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;

          });
      },

      // dispatch dialog in Pending Repair
      dispatchConfirmPopup() {
        // this.dispatchconfirmpopup = true;
        this.repair_id = this.selected.map(repairs => repairs.id);
        const repairDetails = {
          "ids": this.repair_id.join(', '),
        }
        this.$httpSecured.post('/api/v1/warehouse/new_repairs/download_to_be_dispatched_items', {
          "repair_details": repairDetails
        })
        .then(response => {
          if (response.data) {
            const link = document.createElement('a');
            link.href=response.data.url
            link.click()
            this.message = "File downloaded successfully!"
            this.okapproveconfirmpopup = true;
          } else {
            this.showAlert("error", "No Data Found");
          }
        }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
      },

      // Admin dispatch function aftre dispatching in Pending Repair
      adminDispatchItem() {
        this.number++;
        this.vendor_code_update = this.selected.map(repairs => repairs.vendor_code);
        this.repair_id = this.selected.map(repairs => repairs.id);
        const repairDetails = {
          "ids": this.repair_id,
          "status": this.active_tab,
          "vendor_code": this.vendor_code_update,
        }

        this.$httpSecured.put('/api/v1/warehouse/new_repairs/create_dispatch_items', {
          "repair_details": repairDetails
        })
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.dispatchconfirmpopup = false;
              this.okapproveconfirmpopup = true;
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.dispatchconfirmpopup = false;
            this.number = 0;
            this.loading = false;
          });
      },

      // Admin update in Pending-Repair once clicked submit
      adminUpdatePendingRepairItem() {
        this.number++;
        this.repair_id = this.selected.map(repairs => repairs.id);

        const formData = new FormData();
        this.repair_id.forEach((id, index) => {
          formData.append(`repair_details[ids][]`, id);
        });

        formData.append("repair_details[status]", this.active_tab);
        formData.append("repair_details[repair_approval]", ''); 
        formData.append("repair_details[repair_status]", this.rejectPendingRepair); 
        formData.append("repair_details[reason]", this.reason);        
        formData.append("repair_details[job_sheet]", this.file);
        
        this.$httpSecured.put('/api/v1/warehouse/new_repairs/update_details',formData)
          .then(response => {
            if (response.data) {
              this.message = response.data.message;
              this.rejectPendingRepair = null;
              this.updatePendingRepairPopup = false;
              this.okrejectconfirmpopup = true;
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;

          });
      },

      // Admin Approve in Pending-disposition once clicked Approve visible for central user 
      adminApproveDispositionItem() {
        this.number++;
        this.repair_id = this.selected.map(repairs => repairs.id);
        const repairDetails = {
          "ids": this.repair_id,
          "status": this.active_tab,
        }
        this.$httpSecured.post('/api/v1/warehouse/new_repairs/update_disposition_item',
          {
            "repair_details": repairDetails
          },)
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.approveconfirmpopup = false;
              this.okapproveconfirmpopup = true;
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;

          });
      },


      // Admin Reject in Pending-disposition once clicked Reject.... visible for central user  
      adminRejectDispositionItem() {
        this.number++;
        this.repair_id = this.selected.map(repairs => repairs.id);
        const temp = this.repair_id.join(', ');
        const repairDetails = {
          "ids": temp,
        }
        this.$httpSecured.put('/api/v1/warehouse/new_repairs/reject_disposition_item',
          {
            "repair_details": repairDetails
          },)
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.rejectconfirmpopup = false;
              this.okapproveconfirmpopup = true;
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;
          });
      },



      // Apply Filters Function
      applyFilterFunc() {
        this.isFiltering = true;
        this.search_tag = '';
        this.page = 1;
        const params = new URLSearchParams();

        const pageparams = this.getRequestParams(
          this.page,
          this.pageSize
        );

        params.append('page', pageparams['page'])
        params.append('per_page', pageparams['size'])
        if (this.putaway_filter) {
            params.append('putaway', this.putaway_filter);
          }
        // params.append('putaway', this.putaway_filter);

        if (this.active_tab == "Pending Quotation") {

          params.append('article_id', this.article_id_search);
          params.append('status', 'Pending Quotation');

          if (this.grade_search_quo.length > 0)
            params.append('grade', JSON.stringify(this.grade_search_quo.map(item => item)));
          else params.append('grade', this.grade_search_quo);

          this.$httpSecured
            .get('/api/v1/warehouse/new_repairs/index_new', { params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.repairs
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                // this.filterPopup = false;
                // this.article_id_search = '';
                // this.grade_search_quo = [];
                this.loading = false;
                this.selected = [];
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");

              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }
        if (this.active_tab == "Pending Repair Approval") {
          params.append('status', 'Pending Repair Approval')
          params.append('article_id', this.article_id_search);
          params.append('repair_quote_percentage', this.repair_quote_percentage_search);

          // if conditions are added because to send an empty string when the array is empty as per the requirement from backend.
          if (this.grade_search_approval.length > 0)
            params.append('grade', JSON.stringify(this.grade_search_approval.map(item => item)));
          else params.append('grade', this.grade_search_approval);


          if (this.expected_revised_grade_search.length > 0)
            params.append('expected_revised_grade', JSON.stringify(this.expected_revised_grade_search.map(item => item)));
          else params.append('expected_revised_grade', this.expected_revised_grade_search);

          this.$httpSecured
            .get('/api/v1/warehouse/new_repairs/index_new', { params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.repairs
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.filterPopup = false;
                // this.article_id_search = '';
                // this.grade_search_approval = [];
                // this.repair_quote_percentage_search = '';
                // this.expected_revised_grade_search = [];
                this.loading = false;
                this.selected = [];
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }
        if (this.active_tab == "Pending Repair") {

          params.append('status', 'Pending Repair')
          params.append('article_id', this.article_id_search);

          if (this.repair_type_search.length > 0)
            params.append('repair_type', JSON.stringify(this.repair_type_search.map(item => item)))
          else params.append('repair_type', this.repair_type_search);


          if (this.repair_status_search.length > 0)
            params.append('repair_status', JSON.stringify(this.repair_status_search.map(item => item)))
          else params.append('repair_status', this.repair_status_search);


          this.$httpSecured
            .get('/api/v1/warehouse/new_repairs/index_new', { params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.repairs
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.filterPopup = false;
                // this.article_id_search = '';
                // this.repair_type_search = [];
                // this.repair_status_search = [];
                this.loading = false;
                this.selected = [];
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");

              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }
        if (this.active_tab == "Dispatch") {
          if (this.repair_vendor_search.length >= 1) {
            const LastIndex = this.repair_vendor_search.length - 1;
            if (typeof this.repair_vendor_search[LastIndex] !== 'object') {
              this.repair_vendor_search.splice(LastIndex, 1);
            }
          }
          const temp_status = (this.status_search == 'Pending Pick-Up') ? 'pending_pickup' : (this.status_search == 'Pending Packaging') ? 'pending_packaging' : (this.status_search == 'Pending Dispatch') ? 'pending_dispatch' : (this.status_search == 'Pending Disposition') ? 'pending_disposition' : '';
          params.append('repair_order', this.repair_order_number_search);
          params.append('status', temp_status);

          if (this.repair_vendor_search.length > 0)
            params.append('repair_vendor_code', JSON.stringify(this.repair_vendor_search.map(item => item.vendor_code)));
          else params.append('repair_vendor_code', this.repair_vendor_search);

          this.$httpSecured
            .get('/api/v1/warehouse/new_repairs/repair_dispatch_items', { params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.warehouse_order_items
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.filterPopup = false;
                // this.repair_vendor_search = [];
                // this.repair_order_number_search = '';
                // this.repair_status = '';
                this.loading = false;
                // this.status_search = '';
                this.selected = [];
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }
        if (this.active_tab == "Pending Disposition") {

          params.append('status', 'Pending Disposition');
          params.append('article_id', this.article_id_search);

          if (this.grade_search_disposition.length > 0)
            params.append('expected_revised_grade', JSON.stringify(this.grade_search_disposition.map(item => item)))
          else params.append('expected_revised_grade', this.grade_search_disposition)

          params.append('price_min', this.minValue);
          params.append('price_max', this.maxValue)
          this.$httpSecured
            .get('/api/v1/warehouse/new_repairs/index_new', { params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.repairs
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.filterPopup = false;
                // this.article_id_search = '';
                // this.grade_search_disposition = [];
                // this.benchmark_price_search = '';
                // this.minValue = '',
                // this.maxValue = '',
                this.loading = false;
                this.selected = [];
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        }

      },

      // close filter popup and clear all the fields
      closeFilterpopup() {
        this.filterPopup = false;
        this.article_id_search = '';
        this.grade_search_quo = [];
        this.grade_search_approval = [];
        this.repair_quote_percentage_search = '';
        this.expected_revised_grade_search = [];
        this.repair_type_search = [];
        this.repair_status_search = [];
        this.repair_vendor_search = [];
        this.repair_order_number_search = '';
        this.status_search = null;
        this.grade_search_disposition = [];
        this.minValue = '';
        this.maxValue = '';
        this.putaway_filter = null;
      },

      // Repair Status dialog opens when clicked on update button in pending Repair
      updatePendingRepairDialog() {
        this.file = null
        this.updatePendingRepairPopup = true;
        this.repair_id = this.selected.map(repairs => repairs.id)
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_filters_data", { params: { id: this.repair_id } })
          .then(response => {
            if (response.data) {
              this.repair_filter_status = response.data.repair_filter_status
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          })
      },


      // Update close dialog function in Pending-Repair
      updatePendingRepairColsePopup() {
        this.updatePendingRepairPopup = false;
        this.rejectPendingRepair = null;
      },

      // Assigning Dispositions menu in Pending Disposition Screen
      assignDispositionList() {
        this.$httpSecured
          .get("/api/v1/warehouse/new_repairs/get_dispositions")
          .then(response => {
            if (response.data) {
              this.assign_disposition_list = response.data.dispositions;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },


      assignDisposition(item) {
        // post method to send disposition after selecting
        this.repair_id = this.selected.map(repairs => repairs.id)
        const repairDetails = {
          "ids": this.repair_id,
          "disposition": item.original_code,
        }
        this.$httpSecured
          .put("/api/v1/warehouse/new_repairs/update_disposition", {
            "repair_details": repairDetails,
            "status": "Pending Disposition"
          },)
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.okapproveconfirmpopup = true,
                this.selectedDisposition = "",
                this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          })
      },

      disableDispatchPendingRepair() {
        return this.selected.length == 0 || this.selected.some(item => item.current_repair_status == 'Pending dispatch to service center' || item.current_repair_status == 'Pending receipt from service center') ||
          this.selected.some(item => item.repair_type_location == 'Location') ||
          this.selected.some(item => item.repair_type_location == null);
      },

      disableUpdatePendingrepair() {
        return this.selected.length == 0 ||
          (this.selected.some(item => item.current_repair_status == 'Pending dispatch to service center' && item.repair_type_location == 'Service center') ||
          this.selected.some(item => item.current_repair_status == 'Pending repair' && item.repair_type_location == 'Service center') ||
          this.selected.some(item => item.current_repair_status == 'Repaired' && item.repair_type_location == 'Service center') ||
          this.selected.some(item => item.repair_type_location == null));
      },

      isFileTypeValid() {
        if (this.file) {
          const allowedFileTypes = ['.pdf', '.png'];
          const fileType = this.file.name.substring(this.file.name.lastIndexOf('.')).toLowerCase();
          if (!allowedFileTypes.includes(fileType)) {
            console.error('Invalid file type. Only PDF and PNG files are allowed.');
            return false;
          }
        }
        return true;
      },

      cancelAspValues() {
        this.maxValue = '';
        this.minValue = '';
        this.aspValue = false;
      },
      formatNumber(value){
        return typeof value === 'string' ? Number(value.replace(/,/g, '')) : value
      },
      positiveRepairQuotationValue(value){
        if(!(/^(0|[1-9]\d*)(\.\d+)?$/.test(this.formatNumber(value)))){
          this.repair_quotation_value = 0
          return 'Enter a valid number'
        }
        return true;
      },
      navigateToFileUpload() {
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "Pending Repair",
          action:'first_tab'
        });       
        this.$router.push({ name: "LotFileuploadComm" });
      },
    }
  }
</script>

<style scoped>
  .v-dialog:has(.filter-repair) {
    justify-content: right;
    align-items: baseline;
    top: 12rem;
  }

  .link-color {
    color: #0357D0;
    font-size: 14px;
    font-weight: 600;
  }

  .bg-color {
    background: #0357D0;
    color: #ffffff;
  }

  .fieldset {
    background: #0357D0;
  }
  .item-selected {
    margin-top: 29px;
    position: absolute;
    left: 35%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage {
      padding: 8px !important;
    }
  }

  @media (min-height: 1126px) {
    .PaddingItemPerPage {
      padding: 24px !important;
    }
  }
  .margin-action{
    margin-bottom: 25px;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 303px) !important;
  }
  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-radius: 4px;
    border-color: rgba(0,0,0,.42);
    border-style: solid;
  }
  .custom-control_outlined button:focus {
    outline: none;
  }
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .filter_ui{
    margin-left: 26px !important;
  }
 .file_name_css{
    border: 1px solid;
    border-radius: 6px;
    padding: 6px;
 }
</style>
